import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface LeadManagementDashboardState {
    [key: string]: boolean;
}

const initialState: LeadManagementDashboardState = {
    name: true,
    phone: true,
    createdAt: true,
    updatedAt: true,
    source: true,
    campaign: true,
    assignedTo: true,
    subAgent: true,
    admissionStatus: true,
    stage: true,
    priority: true,
    followUp: true,
    lastRemark: true,
    actions: true,
    destinations: true,
    intakeMonth: true,
    intakeYear: true,
};

const leadManagementDashboardSlice = createSlice({
    name: 'leadManagementDashboard',
    initialState,
    reducers: {
        setDashboardProps: (state, action: PayloadAction<{ key: string; value: boolean }>) => {
            if (state.hasOwnProperty(action.payload.key)) {
                console.log('action.payload.key', action.payload.key);
                console.log('action.payload.value', action.payload.value);
                
                state[action.payload.key] = action.payload.value;
            }
        },

        // clear all lead management dashboard props
        reset: () => initialState,
    },
});

export const { setDashboardProps, reset } = leadManagementDashboardSlice.actions;

export default leadManagementDashboardSlice.reducer; 